/* Validazione modulo contatti (speculare a quella del server) + suggerimento domini email scritti male. */
const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const PHONE_RE = /^\+?[0-9 ]+$/;

export const validateContact = (form) => {
    const errors = {};
    if (form.nome.trim().length < 2) errors.nome = "Inserisca il Suo nome (almeno 2 caratteri)";
    if (!EMAIL_RE.test(form.email.trim())) errors.email = "Inserisca un indirizzo email valido";
    const tel = form.telefono.trim();
    if (tel && (!PHONE_RE.test(tel) || tel.replace(/\D/g, "").length < 9)) {
        errors.telefono = "Inserisca un numero valido: solo cifre, spazi e +, almeno 9 cifre";
    }
    if (form.messaggio.trim().length < 10) errors.messaggio = "Scriva un messaggio di almeno 10 caratteri";
    return errors;
};

const DOMAIN_FIXES = {
    "gmail.con": "gmail.com", "gmail.co": "gmail.com", "gmail.cm": "gmail.com", "gmial.com": "gmail.com", "gmai.com": "gmail.com",
    "gamil.com": "gmail.com", "gmali.com": "gmail.com", "gmail.it": "gmail.com", "googlemail.con": "googlemail.com",
    "hotmial.com": "hotmail.com", "hotmai.com": "hotmail.com", "hotmail.con": "hotmail.com", "hotmail.co": "hotmail.com",
    "hotmial.it": "hotmail.it", "hotmail.ti": "hotmail.it", "hotmai.it": "hotmail.it",
    "outlok.it": "outlook.it", "outlook.ti": "outlook.it", "outlok.com": "outlook.com", "outloook.com": "outlook.com", "outlook.con": "outlook.com",
    "libero.ti": "libero.it", "liber.it": "libero.it", "libero.com": "libero.it", "lbero.it": "libero.it",
    "alice.ti": "alice.it", "alic.it": "alice.it", "tiscali.ti": "tiscali.it", "tiscal.it": "tiscali.it",
    "virgilio.ti": "virgilio.it", "virgilo.it": "virgilio.it", "yaho.com": "yahoo.com", "yahoo.con": "yahoo.com", "yahoo.ti": "yahoo.it",
    "pec.ti": "pec.it", "icloud.con": "icloud.com", "iclod.com": "icloud.com", "live.ti": "live.it", "live.con": "live.com",
};

export const suggestEmail = (email) => {
    const m = email.trim().toLowerCase().match(/^([^@]+)@(.+)$/);
    if (!m) return null;
    const fix = DOMAIN_FIXES[m[2]];
    return fix ? `${m[1]}@${fix}` : null;
};
